import { useFormikContext } from 'formik';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';

import { EmailPreview } from './EmailPreview';
import { ShareValues } from './Sequences/ShareWebsiteEmail';

interface Props {
  matchPath: string;
  editRoute: string;
  displayName?: string;
  showLinkButton?: boolean;
}

enum MsgType {
  SUBJECT = 'SUBJECT',
  BODY = 'BODY',
  BUTTON = 'BUTTON',
}

type Msg = { type: MsgType; value: string };

export const EmailPreviewContainer: React.FC<Props> = ({
  matchPath,
  editRoute,
  displayName,
  showLinkButton = true,
}) => {
  const { values } = useFormikContext<ShareValues>();
  const match = useRouteMatch(matchPath);
  // Need to get params from / and /edit
  const previewMatch = useRouteMatch<{ seqId: string }>({ path: matchPath.replace('edit', ''), strict: false });
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [loaded, setLoaded] = useState(false);

  const sendMessage = useCallback(
    (msg: Msg) => {
      if (loaded && iframeRef.current) {
        iframeRef.current.contentWindow?.postMessage(JSON.stringify(msg), process.env.REACT_APP_GMS_URL);
      }
    },
    [loaded]
  );

  useEffect(() => {
    const msg = { type: MsgType.SUBJECT, value: values.subject };
    sendMessage(msg);
  }, [values.subject, sendMessage]);

  useEffect(() => {
    const msg = { type: MsgType.BODY, value: values.message };
    sendMessage(msg);
  }, [values.message, sendMessage]);

  useEffect(() => {
    if (values.linkButtonText) {
      const msg = { type: MsgType.BUTTON, value: values.linkButtonText };
      sendMessage(msg);
    }
  }, [values.linkButtonText, sendMessage]);

  return (
    <>
      <EmailPreview
        editRoute={editRoute}
        match={match}
        seqId={previewMatch?.params.seqId}
        setLoaded={setLoaded}
        iframeRef={iframeRef}
        subject={values.subject}
        showLinkButton={showLinkButton}
      />
    </>
  );
};
